import { render, staticRenderFns } from "./MoonPrice.vue?vue&type=template&id=c51c5a1e&scoped=true&"
import script from "./MoonPrice.vue?vue&type=script&lang=js&"
export * from "./MoonPrice.vue?vue&type=script&lang=js&"
import style0 from "./MoonPrice.vue?vue&type=style&index=0&id=c51c5a1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51c5a1e",
  null
  
)

export default component.exports